<table class="table">
    <tr>
        <th>File Name</th>
        <th>Uploaded By</th>
        <th>Upload Date</th>
        <th>Comment</th>
    </tr>
    <tr  *ngFor="let f of observationFiles">
        <td>
            <ng-template ngFor let-contentRow [ngForOf]="filteredActions?.value | filterNested:CommentTags.Attachment">
                <ng-container [ngTemplateOutlet]="contentRow.templateRef" [ngTemplateOutletContext]="{ $implicit: f }"></ng-container>
            </ng-template>
            <span *ngIf="!(filteredActions?.value | hasNested:CommentTags.Attachment)">{{ f.fileName }}</span>
        </td>
        <td>{{f.displayName}}</td>
        <td>{{f.uploadDate | date}}</td>
        <td>{{getCommentLabel(f)}}</td>
    </tr>
</table>
